import React from 'react';
import {
  createRoutesFromElements,
  createBrowserRouter,
  Route,
  Navigate,
} from 'react-router-dom';

import CreateAssessmentForm from 'components/CreateAssessment/CreateAssessmentForm';
import CreatePracticeAssessmentForm from 'components/CreateAssessment/CreatePracticeAssessmentForm';
import SelectAssessmentType from 'components/CreateAssessment/SelectAssessmentType';
import Home from 'components/Home/Home';
import AllSteps from 'pages/AllSteps/AllSteps';
import ClosingVideo from 'pages/ClosingVideo/ClosingVideo';
import Competency from 'pages/Competency/Competency';
import DeviceSetup from 'pages/DeviceSetup/DeviceSetup';
import Integrations from 'pages/Integrations/Integrations';
import NotFound from 'pages/NotFound/NotFound';
import Overview from 'pages/Overview/Overview';
import Payment from 'pages/Payment/Payment';
import PracticeAssessment from 'pages/PracticeAssessment/PracticeAssessment';
import Registration from 'pages/Registration/Registration';
import Settings from 'pages/Settings/Settings';
import SettingsEmail from 'pages/SettingsEmail/SettingsEmail';
import SettingsGeneral from 'pages/SettingsGeneral/SettingsGeneral';
import Steps from 'pages/Steps/Steps';
import SupplementalMaterials from 'pages/SupplementalMaterials/SupplementalMaterials';
import WelcomeVideo from 'pages/WelcomeVideo/WelcomeVideo';
import ProtectedRoute from 'routes/ProtectedRoute';

import App from './App';

export enum RouteIds {
  InterviewHome = 'interviewHome',
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<ProtectedRoute />} errorElement={<NotFound />}>
      <Route path="/" element={<App />}>
        <Route path="/" element={<SelectAssessmentType />} />
        <Route path="/create-assessment" element={<CreateAssessmentForm />} />
        <Route
          path="/create-practice"
          element={<CreatePracticeAssessmentForm />}
        />
        <Route
          path="/interview/:interviewUid"
          id={RouteIds.InterviewHome}
          element={<Home />}
        >
          <Route index element={<Navigate to="overview" />} />
          <Route path="overview" element={<Overview />} />
          <Route path="steps" element={<Steps />}>
            <Route index element={<Navigate to="all-steps" />} />
            <Route path="all-steps" element={<AllSteps />} />
            <Route path="welcome-video" element={<WelcomeVideo />} />
            <Route path="registration" element={<Registration />} />
            <Route
              path="supplemental-materials"
              element={<SupplementalMaterials />}
            />
            <Route path="device-setup" element={<DeviceSetup />} />
            <Route path="practice" element={<PracticeAssessment />} />
            <Route path="payment" element={<Payment />} />
            <Route path="competency/:competencyUid" element={<Competency />} />
            <Route path="closing-video" element={<ClosingVideo />} />
          </Route>
          <Route path="settings" element={<Settings />}>
            <Route index element={<Navigate to="general" />} />
            <Route path="general" element={<SettingsGeneral />} />
            <Route path="email" element={<SettingsEmail />} />
            <Route path="integrations" element={<Integrations />} />
          </Route>
        </Route>
      </Route>
    </Route>
  )
);

export default router;
